import { ApiClient } from '../../services/ApiClient';
import { ToastManager } from '../components/Toast';
import { DialogManager } from '../components/DialogManager';

export class AdminView {
  static async render(container: HTMLElement): Promise<void> {
    container.innerHTML = `
      <div style="max-width: 1200px; margin: 40px auto; padding: 0 20px; width: 100%; display: flex; flex-direction: column; gap: 30px;">
        <div class="glass-panel" style="padding: 30px;">
          <h1 style="font-size: 2rem; font-weight: 800; color: #f8fafc; margin-bottom: 20px; display: flex; align-items: center; gap: 12px;">
            🛡️ Yönetim Paneli
          </h1>
          <p style="color: #94a3b8; font-size: 1rem; margin-bottom: 30px;">Kullanıcıları yönetin, hataları inceleyin ve sistem günlüklerini takip edin.</p>
          
          <!-- Tabs -->
          <div style="display: flex; flex-wrap: wrap; gap: 16px; margin-bottom: 24px; border-bottom: 1px solid #334155; padding-bottom: 16px;">
            <button class="admin-tab-btn active" data-tab="users">Kullanıcı Yönetimi</button>
            <button class="admin-tab-btn" data-tab="feedbacks">Hata Bildirimleri</button>
            <button class="admin-tab-btn" data-tab="errors">Sistem Hataları</button>
            <button class="admin-tab-btn" data-tab="analytics">📊 Kullanıcı Analitiği</button>
          </div>

          <!-- Tab Content Containers -->
          <div id="admin-tab-users" class="admin-tab-content">
            <div style="display: flex; flex-wrap: wrap; gap: 12px; justify-content: space-between; align-items: center; margin-bottom: 16px;">
              <h2 style="font-size: 1.3rem; font-weight: 700; color: #e2e8f0;">Kayıtlı Kullanıcılar</h2>
              <button id="refresh-users-btn" style="padding: 8px 16px; background: #334155; color: #fff; border-radius: 6px; border: none; cursor: pointer;">Yenile</button>
            </div>
            <div class="table-responsive" style="overflow-x: auto;">
              <table style="width: 100%; border-collapse: collapse; text-align: left; min-width: 600px;">
                <thead>
                  <tr style="border-bottom: 2px solid #334155; color: #94a3b8;">
                    <th style="padding: 12px;">ID</th>
                    <th style="padding: 12px;">Kullanıcı Adı</th>
                    <th style="padding: 12px;">E-posta</th>
                    <th style="padding: 12px;">Rol</th>
                    <th style="padding: 12px;">Kayıt Tarihi</th>
                    <th style="padding: 12px; text-align: right;">İşlemler</th>
                  </tr>
                </thead>
                <tbody id="admin-users-list">
                  <tr><td colspan="6" style="text-align:center; padding:20px; color:#64748b;">Yükleniyor...</td></tr>
                </tbody>
              </table>
            </div>
          </div>

          <div id="admin-tab-feedbacks" class="admin-tab-content" style="display: none;">
            <div style="display: flex; flex-wrap: wrap; gap: 12px; justify-content: space-between; align-items: center; margin-bottom: 16px;">
              <h2 style="font-size: 1.3rem; font-weight: 700; color: #e2e8f0;">Gelen Bildirimler</h2>
              <div style="display: flex; flex-wrap: wrap; gap: 12px;">
                <button id="batch-delete-feedbacks-btn" style="padding: 8px 16px; background: #ef4444; color: #fff; border-radius: 6px; border: none; cursor: pointer; display: none;">Seçilenleri Sil</button>
                <button id="delete-all-feedbacks-btn" style="padding: 8px 16px; background: #991b1b; color: #fff; border-radius: 6px; border: none; cursor: pointer;">Tümünü Sil</button>
                <button id="download-feedbacks-btn" style="padding: 8px 16px; background: #10b981; color: #fff; border-radius: 6px; border: none; cursor: pointer; display: flex; align-items: center; gap: 8px;">
                  <span>⬇️</span> CSV İndir
                </button>
                <button id="refresh-feedbacks-btn" style="padding: 8px 16px; background: #334155; color: #fff; border-radius: 6px; border: none; cursor: pointer;">Yenile</button>
              </div>
            </div>
            <div class="table-responsive" style="overflow-x: auto;">
              <table style="width: 100%; border-collapse: collapse; text-align: left; min-width: 800px;">
                <thead>
                  <tr style="border-bottom: 2px solid #334155; color: #94a3b8;">
                    <th style="padding: 12px; width: 5%;"><input type="checkbox" id="select-all-feedbacks" style="cursor: pointer;" /></th>
                    <th style="padding: 12px; width: 15%;">Tarih</th>
                    <th style="padding: 12px; width: 15%;">Kullanıcı</th>
                    <th style="padding: 12px; width: 15%;">Oyun</th>
                    <th style="padding: 12px; width: 45%;">Mesaj</th>
                    <th style="padding: 12px; width: 10%; text-align: right;">İşlem</th>
                  </tr>
                </thead>
                <tbody id="admin-feedbacks-list">
                  <tr><td colspan="5" style="text-align:center; padding:20px; color:#64748b;">Yükleniyor...</td></tr>
                </tbody>
              </table>
            </div>
          </div>

          <div id="admin-tab-errors" class="admin-tab-content" style="display: none;">
            <div style="display: flex; flex-wrap: wrap; gap: 12px; justify-content: space-between; align-items: center; margin-bottom: 16px;">
              <h2 style="font-size: 1.3rem; font-weight: 700; color: #e2e8f0;">Sistem Hataları (Log)</h2>
              <div style="display: flex; flex-wrap: wrap; gap: 12px;">
                <button id="batch-delete-errors-btn" style="padding: 8px 16px; background: #ef4444; color: #fff; border-radius: 6px; border: none; cursor: pointer; display: none;">Seçilenleri Sil</button>
                <button id="delete-all-errors-btn" style="padding: 8px 16px; background: #991b1b; color: #fff; border-radius: 6px; border: none; cursor: pointer;">Tümünü Sil</button>
                <button id="download-errors-btn" style="padding: 8px 16px; background: #10b981; color: #fff; border-radius: 6px; border: none; cursor: pointer; display: flex; align-items: center; gap: 8px;">
                  <span>⬇️</span> CSV İndir
                </button>
                <button id="refresh-errors-btn" style="padding: 8px 16px; background: #334155; color: #fff; border-radius: 6px; border: none; cursor: pointer;">Yenile</button>
              </div>
            </div>
            <div class="table-responsive" style="overflow-x: auto;">
              <table style="width: 100%; border-collapse: collapse; text-align: left; min-width: 800px;">
                <thead>
                  <tr style="border-bottom: 2px solid #334155; color: #94a3b8;">
                    <th style="padding: 12px; width: 5%;"><input type="checkbox" id="select-all-errors" style="cursor: pointer;" /></th>
                    <th style="padding: 12px; width: 15%;">Tarih</th>
                    <th style="padding: 12px; width: 25%;">Hata Mesajı</th>
                    <th style="padding: 12px; width: 20%;">URL</th>
                    <th style="padding: 12px; width: 25%;">Stack Trace</th>
                    <th style="padding: 12px; width: 10%; text-align: right;">İşlem</th>
                  </tr>
                </thead>
                <tbody id="admin-errors-list">
                  <tr><td colspan="6" style="text-align:center; padding:20px; color:#64748b;">Yükleniyor...</td></tr>
                </tbody>
              </table>
            </div>
          </div>

          <div id="admin-tab-analytics" class="admin-tab-content" style="display: none;">
            <div style="text-align:center; color:#64748b; padding:40px;">Analitik sekmesine geçmek için yukarıdaki butona tıklayın.</div>
          </div>

        </div>
      </div>
      <style>
        .admin-tab-btn {
          padding: 10px 20px;
          background: transparent;
          color: #94a3b8;
          border: 1px solid transparent;
          border-radius: 8px;
          cursor: pointer;
          font-weight: 600;
          transition: all 0.2s;
        }
        .admin-tab-btn:hover {
          color: #f8fafc;
          background: rgba(51, 65, 85, 0.5);
        }
        .admin-tab-btn.active {
          color: #fff;
          background: #6366f1;
          border-color: #4f46e5;
        }
        #admin-users-list tr, #admin-feedbacks-list tr, #admin-errors-list tr {
          border-bottom: 1px solid #1e293b;
        }
        #admin-users-list tr:hover, #admin-feedbacks-list tr:hover, #admin-errors-list tr:hover {
          background: rgba(30, 41, 59, 0.5);
        }
      </style>
    `;

    // Tab Switching Logic
    const tabs = container.querySelectorAll('.admin-tab-btn');
    const contents = container.querySelectorAll('.admin-tab-content');
    
    tabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        const target = (e.currentTarget as HTMLElement).getAttribute('data-tab');
        
        tabs.forEach(t => t.classList.remove('active'));
        (e.currentTarget as HTMLElement).classList.add('active');
        
        contents.forEach(c => (c as HTMLElement).style.display = 'none');
        const activeContent = container.querySelector(`#admin-tab-${target}`) as HTMLElement;
        if (activeContent) activeContent.style.display = 'block';
        
        if (target === 'users') AdminView.loadUsers();
        if (target === 'feedbacks') AdminView.loadFeedbacks();
        if (target === 'errors') AdminView.loadErrors();
        if (target === 'analytics') AdminView.loadAnalyticsTab();
      });
    });

    // Refresh Buttons
    document.getElementById('refresh-users-btn')?.addEventListener('click', () => AdminView.loadUsers());
    document.getElementById('refresh-feedbacks-btn')?.addEventListener('click', () => AdminView.loadFeedbacks());
    document.getElementById('refresh-errors-btn')?.addEventListener('click', () => AdminView.loadErrors());

    // CSV Download Buttons
    document.getElementById('download-feedbacks-btn')?.addEventListener('click', () => AdminView.downloadFeedbacksCSV());
    document.getElementById('download-errors-btn')?.addEventListener('click', () => AdminView.downloadErrorsCSV());

    // Batch Actions
    // --- Feedbacks Batch Actions ---
    document.getElementById('select-all-feedbacks')?.addEventListener('change', (e) => {
      const isChecked = (e.target as HTMLInputElement).checked;
      const checkboxes = document.querySelectorAll('.feedback-row-checkbox') as NodeListOf<HTMLInputElement>;
      checkboxes.forEach(cb => cb.checked = isChecked);
      AdminView.toggleBatchDeleteFeedbacksBtn();
    });

    document.getElementById('batch-delete-feedbacks-btn')?.addEventListener('click', async () => {
      const checkboxes = document.querySelectorAll('.feedback-row-checkbox:checked') as NodeListOf<HTMLInputElement>;
      const ids = Array.from(checkboxes).map(cb => Number(cb.value)).filter(id => !isNaN(id));
      if (ids.length === 0) return;
      if (await DialogManager.confirm(`Seçili ${ids.length} bildirimi silmek istediğinize emin misiniz?`)) {
        await ApiClient.deleteMultipleFeedbacks(ids);
        ToastManager.show('Seçili bildirimler silindi', 'success');
        const selectAllCb = document.getElementById('select-all-feedbacks') as HTMLInputElement;
        if (selectAllCb) selectAllCb.checked = false;
        AdminView.toggleBatchDeleteFeedbacksBtn();
        AdminView.loadFeedbacks();
      }
    });

    document.getElementById('delete-all-feedbacks-btn')?.addEventListener('click', async () => {
      if (await DialogManager.confirm('DİKKAT: Sistemdeki TÜM bildirimleri kalıcı olarak silmek istediğinize emin misiniz?')) {
        await ApiClient.deleteAllFeedbacks();
        ToastManager.show('Tüm bildirimler temizlendi', 'success');
        const selectAllCb = document.getElementById('select-all-feedbacks') as HTMLInputElement;
        if (selectAllCb) selectAllCb.checked = false;
        AdminView.toggleBatchDeleteFeedbacksBtn();
        AdminView.loadFeedbacks();
      }
    });

    // --- Errors Batch Actions ---
    document.getElementById('select-all-errors')?.addEventListener('change', (e) => {
      const isChecked = (e.target as HTMLInputElement).checked;
      const checkboxes = document.querySelectorAll('.error-row-checkbox') as NodeListOf<HTMLInputElement>;
      checkboxes.forEach(cb => cb.checked = isChecked);
      AdminView.toggleBatchDeleteErrorsBtn();
    });

    document.getElementById('batch-delete-errors-btn')?.addEventListener('click', async () => {
      const checkboxes = document.querySelectorAll('.error-row-checkbox:checked') as NodeListOf<HTMLInputElement>;
      const ids = Array.from(checkboxes).map(cb => Number(cb.value)).filter(id => !isNaN(id));
      if (ids.length === 0) return;
      if (await DialogManager.confirm(`Seçili ${ids.length} hatayı silmek istediğinize emin misiniz?`)) {
        await ApiClient.deleteMultipleSystemErrors(ids);
        ToastManager.show('Seçili hatalar silindi', 'success');
        const selectAllCb = document.getElementById('select-all-errors') as HTMLInputElement;
        if (selectAllCb) selectAllCb.checked = false;
        AdminView.toggleBatchDeleteErrorsBtn();
        AdminView.loadErrors();
      }
    });

    document.getElementById('delete-all-errors-btn')?.addEventListener('click', async () => {
      if (await DialogManager.confirm('DİKKAT: Sistemdeki TÜM hataları kalıcı olarak silmek istediğinize emin misiniz?')) {
        await ApiClient.deleteAllSystemErrors();
        ToastManager.show('Tüm hatalar temizlendi', 'success');
        const selectAllCb = document.getElementById('select-all-errors') as HTMLInputElement;
        if (selectAllCb) selectAllCb.checked = false;
        AdminView.toggleBatchDeleteErrorsBtn();
        AdminView.loadErrors();
      }
    });

    // Initial Load
    AdminView.loadUsers();
  }

  private static toggleBatchDeleteErrorsBtn() {
    const btn = document.getElementById('batch-delete-errors-btn');
    const checkedCount = document.querySelectorAll('.error-row-checkbox:checked').length;
    if (btn) {
      btn.style.display = checkedCount > 0 ? 'inline-block' : 'none';
      btn.textContent = `Seçilenleri Sil (${checkedCount})`;
    }
  }

  private static toggleBatchDeleteFeedbacksBtn() {
    const btn = document.getElementById('batch-delete-feedbacks-btn');
    const checkedCount = document.querySelectorAll('.feedback-row-checkbox:checked').length;
    if (btn) {
      btn.style.display = checkedCount > 0 ? 'inline-block' : 'none';
      btn.textContent = `Seçilenleri Sil (${checkedCount})`;
    }
  }

  // --- Users ---
  private static async loadUsers() {
    const list = document.getElementById('admin-users-list');
    if (!list) return;
    
    list.innerHTML = `<tr><td colspan="6" style="text-align:center; padding:20px; color:#64748b;">Yükleniyor...</td></tr>`;
    
    const res = await ApiClient.getUsers();
    if (res.error || !res.data) {
      list.innerHTML = `<tr><td colspan="6" style="text-align:center; padding:20px; color:#ef4444;">${res.error || 'Hata'}</td></tr>`;
      return;
    }

    if (res.data.length === 0) {
      list.innerHTML = `<tr><td colspan="6" style="text-align:center; padding:20px; color:#64748b;">Kullanıcı bulunamadı.</td></tr>`;
      return;
    }

    list.innerHTML = res.data.map((u: any) => `
      <tr>
        <td style="padding: 12px; font-size: 0.85rem; color: #94a3b8;">${(u.id || '').substring(0, 8)}...</td>
        <td style="padding: 12px; color: #e2e8f0; font-weight: 600;">${u.username || 'Anonim'}</td>
        <td style="padding: 12px; color: #cbd5e1;">${u.email || '-'}</td>
        <td style="padding: 12px;">
          <span style="padding: 4px 8px; border-radius: 4px; font-size: 0.8rem; font-weight: 600; background: ${u.role === 'admin' ? 'rgba(99, 102, 241, 0.2)' : 'rgba(100, 116, 139, 0.2)'}; color: ${u.role === 'admin' ? '#818cf8' : '#cbd5e1'};">
            ${u.role.toUpperCase()}
          </span>
        </td>
        <td style="padding: 12px; font-size: 0.85rem; color: #94a3b8;">${new Date(u.created_at || '').toLocaleDateString()}</td>
        <td style="padding: 12px; text-align: right; display: flex; gap: 8px; justify-content: flex-end;">
          <button data-action="toggle-role" data-id="${u.id}" data-role="${u.role}" style="padding: 6px 12px; background: #334155; color: #fff; border-radius: 4px; border: none; cursor: pointer; font-size: 0.8rem;">
            Rol Değiştir
          </button>
          <button data-action="delete-user" data-id="${u.id}" style="padding: 6px 12px; background: #ef4444; color: #fff; border-radius: 4px; border: none; cursor: pointer; font-size: 0.8rem;">
            Sil
          </button>
        </td>
      </tr>
    `).join('');

    // Bind events
    list.querySelectorAll('button[data-action="toggle-role"]').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        const id = (e.currentTarget as HTMLElement).getAttribute('data-id');
        const currentRole = (e.currentTarget as HTMLElement).getAttribute('data-role');
        if (id) {
          const newRole = currentRole === 'admin' ? 'user' : 'admin';
          if (await DialogManager.confirm(`Bu kullanıcının rolünü "${newRole}" yapmak istediğinize emin misiniz?`)) {
            await ApiClient.updateUserRole(id, newRole);
            ToastManager.show('Rol güncellendi', 'success');
            AdminView.loadUsers();
          }
        }
      });
    });

    list.querySelectorAll('button[data-action="delete-user"]').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        const id = (e.currentTarget as HTMLElement).getAttribute('data-id');
        if (id) {
          if (await DialogManager.confirm('DİKKAT: Kullanıcı kalıcı olarak silinecek. Onaylıyor musunuz?')) {
            await ApiClient.deleteUser(id);
            ToastManager.show('Kullanıcı silindi', 'success');
            AdminView.loadUsers();
          }
        }
      });
    });
  }

  // --- Feedbacks ---
  private static cachedFeedbacks: any[] = [];
  
  private static async loadFeedbacks() {
    const list = document.getElementById('admin-feedbacks-list');
    if (!list) return;
    
    list.innerHTML = `<tr><td colspan="5" style="text-align:center; padding:20px; color:#64748b;">Yükleniyor...</td></tr>`;
    
    const res = await ApiClient.getFeedbacks();
    if (res.error || !res.data) {
      list.innerHTML = `<tr><td colspan="5" style="text-align:center; padding:20px; color:#ef4444;">${res.error || 'Hata'}</td></tr>`;
      return;
    }

    this.cachedFeedbacks = res.data;

    if (res.data.length === 0) {
      list.innerHTML = `<tr><td colspan="6" style="text-align:center; padding:20px; color:#64748b;">Hiç bildirim bulunamadı.</td></tr>`;
      return;
    }

    list.innerHTML = res.data.map((f: any) => `
      <tr>
        <td style="padding: 12px;"><input type="checkbox" class="feedback-row-checkbox" value="${f.id}" style="cursor: pointer;" /></td>
        <td style="padding: 12px; font-size: 0.85rem; color: #94a3b8;">${new Date(f.created_at).toLocaleString()}</td>
        <td style="padding: 12px; color: #e2e8f0; font-weight: 600;">
          ${f.username || 'Misafir'}<br/>
          <span style="font-size:0.75rem; color:#64748b;">${f.email || ''}</span>
        </td>
        <td style="padding: 12px; color: #cbd5e1;">${f.game_id}</td>
        <td style="padding: 12px; color: #cbd5e1; font-size: 0.9rem; line-height: 1.4; white-space: pre-wrap;">${this.escapeHtml(f.message)}</td>
        <td style="padding: 12px; text-align: right;">
          <button data-action="delete-feedback" data-id="${f.id}" style="padding: 6px 12px; background: #ef4444; color: #fff; border-radius: 4px; border: none; cursor: pointer; font-size: 0.8rem;">
            Sil
          </button>
        </td>
      </tr>
    `).join('');

    list.querySelectorAll('.feedback-row-checkbox').forEach(cb => {
      cb.addEventListener('change', () => AdminView.toggleBatchDeleteFeedbacksBtn());
    });

    list.querySelectorAll('button[data-action="delete-feedback"]').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        const id = Number((e.currentTarget as HTMLElement).getAttribute('data-id'));
        if (id && await DialogManager.confirm('Bu bildirimi silmek istiyor musunuz?')) {
          await ApiClient.deleteFeedback(id);
          ToastManager.show('Bildirim silindi', 'success');
          AdminView.loadFeedbacks();
        }
      });
    });
  }

  // --- Errors ---
  private static cachedErrors: any[] = [];
  
  private static async loadErrors() {
    const list = document.getElementById('admin-errors-list');
    if (!list) return;
    
    list.innerHTML = `<tr><td colspan="6" style="text-align:center; padding:20px; color:#64748b;">Yükleniyor...</td></tr>`;
    
    const res = await ApiClient.getSystemErrors();
    if (res.error || !res.data) {
      list.innerHTML = `<tr><td colspan="6" style="text-align:center; padding:20px; color:#ef4444;">${res.error || 'Hata'}</td></tr>`;
      return;
    }

    this.cachedErrors = res.data;

    if (res.data.length === 0) {
      list.innerHTML = `<tr><td colspan="6" style="text-align:center; padding:20px; color:#64748b;">Sistem hatası bulunamadı. Harika!</td></tr>`;
      return;
    }

    list.innerHTML = res.data.map((err: any) => `
      <tr>
        <td style="padding: 12px;"><input type="checkbox" class="error-row-checkbox" value="${err.id}" style="cursor: pointer;" /></td>
        <td style="padding: 12px; font-size: 0.85rem; color: #94a3b8;">${new Date(err.created_at).toLocaleString()}</td>
        <td style="padding: 12px; color: #ef4444; font-weight: 600; font-size: 0.9rem;">${this.escapeHtml(err.message)}</td>
        <td style="padding: 12px; color: #cbd5e1; font-size: 0.8rem; word-break: break-all;">${this.escapeHtml(err.url)}</td>
        <td style="padding: 12px; color: #64748b; font-size: 0.75rem; max-height: 80px; overflow-y: auto; display: block; white-space: pre-wrap; font-family: monospace;">${this.escapeHtml(err.stack || '')}</td>
        <td style="padding: 12px; text-align: right;">
          <button data-action="delete-error" data-id="${err.id}" style="padding: 6px 12px; background: #334155; color: #fff; border-radius: 4px; border: none; cursor: pointer; font-size: 0.8rem;">
            Sil
          </button>
        </td>
      </tr>
    `).join('');

    list.querySelectorAll('.error-row-checkbox').forEach(cb => {
      cb.addEventListener('change', () => AdminView.toggleBatchDeleteErrorsBtn());
    });

    list.querySelectorAll('button[data-action="delete-error"]').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        const id = Number((e.currentTarget as HTMLElement).getAttribute('data-id'));
        if (id && await DialogManager.confirm('Hata kaydını silmek istiyor musunuz?')) {
          await ApiClient.deleteSystemError(id);
          ToastManager.show('Hata silindi', 'success');
          AdminView.loadErrors();
        }
      });
    });
  }

  // --- Utilities ---
  
  private static escapeHtml(unsafe: string) {
    if (!unsafe) return '';
    return unsafe
         .replace(/&/g, "&amp;")
         .replace(/</g, "&lt;")
         .replace(/>/g, "&gt;")
         .replace(/"/g, "&quot;")
         .replace(/'/g, "&#039;");
  }

  private static downloadCSV(filename: string, rows: any[][]) {
    const processRow = function (row: any[]) {
      let finalVal = '';
      for (let j = 0; j < row.length; j++) {
        let innerValue = row[j] === null ? '' : row[j].toString();
        if (row[j] instanceof Date) {
          innerValue = row[j].toLocaleString();
        }
        let result = innerValue.replace(/"/g, '""');
        if (result.search(/("|,|\n)/g) >= 0)
          result = '"' + result + '"';
        if (j > 0)
          finalVal += ',';
        finalVal += result;
      }
      return finalVal + '\n';
    };

    let csvFile = '';
    for (let i = 0; i < rows.length; i++) {
      csvFile += processRow(rows[i]);
    }

    const blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement("a");
    if (link.download !== undefined) { 
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  private static downloadFeedbacksCSV() {
    if (!this.cachedFeedbacks || this.cachedFeedbacks.length === 0) {
      ToastManager.show('İndirilecek veri yok', 'warning');
      return;
    }
    const header = ['Tarih', 'KullaniciAdi', 'Email', 'Oyun_ID', 'Mesaj'];
    const rows = this.cachedFeedbacks.map(f => [
      new Date(f.created_at).toLocaleString(),
      f.username || 'Misafir',
      f.email || '',
      f.game_id,
      f.message
    ]);
    this.downloadCSV('hata_bildirimleri.csv', [header, ...rows]);
  }

  private static downloadErrorsCSV() {
    if (!this.cachedErrors || this.cachedErrors.length === 0) {
      ToastManager.show('İndirilecek veri yok', 'warning');
      return;
    }
    const header = ['Tarih', 'URL', 'Mesaj', 'Stack Trace'];
    const rows = this.cachedErrors.map(e => [
      new Date(e.created_at).toLocaleString(),
      e.url,
      e.message,
      e.stack
    ]);
    this.downloadCSV('sistem_hatalari.csv', [header, ...rows]);
  }

  // ─── Analytics Tab ────────────────────────────────────────────────────────

  static async loadAnalyticsTab(): Promise<void> {
    const container = document.getElementById('admin-tab-analytics');
    if (!container) return;

    container.innerHTML = `
      <div style="display:flex; flex-direction:column; gap:24px;">
        <!-- Guest Stats Cards -->
        <div>
          <h2 style="font-size:1.3rem; font-weight:700; color:#e2e8f0; margin-bottom:16px;">👤 Misafir Kullanıcı İstatistikleri</h2>
          <div id="guest-stats-cards" style="display:grid; grid-template-columns:repeat(auto-fill,minmax(160px,1fr)); gap:12px;">
            <div style="text-align:center; color:#64748b;">Yükleniyor...</div>
          </div>
        </div>

        <!-- Guest Top Games -->
        <div class="glass-panel" style="padding:20px;">
          <h3 style="font-size:1.1rem; font-weight:700; color:#e2e8f0; margin-bottom:16px;">🎮 Misafirlerin En Çok Oynadığı Oyunlar</h3>
          <div id="guest-top-games" style="display:flex; flex-direction:column; gap:8px;">
            <div style="text-align:center; color:#64748b;">Yükleniyor...</div>
          </div>
        </div>

        <!-- Registered User Analytics -->
        <div>
          <h2 style="font-size:1.3rem; font-weight:700; color:#e2e8f0; margin-bottom:16px;">📊 Kayıtlı Kullanıcı Analitiği</h2>
          <div style="display:grid; grid-template-columns:280px 1fr; gap:20px; align-items:start;">
            <!-- User List -->
            <div class="glass-panel" style="padding:16px; max-height:500px; overflow-y:auto;">
              <h3 style="font-size:0.9rem; font-weight:700; color:#94a3b8; margin-bottom:12px; text-transform:uppercase; letter-spacing:0.05em;">Kullanıcılar</h3>
              <div id="analytics-user-list" style="display:flex; flex-direction:column; gap:6px;">Yükleniyor...</div>
            </div>
            <!-- User Detail Panel -->
            <div id="analytics-user-detail" class="glass-panel" style="padding:24px; min-height:300px;">
              <div style="text-align:center; color:#64748b; padding-top:60px;">← Soldan bir kullanıcı seçin</div>
            </div>
          </div>
        </div>
      </div>
    `;

    await AdminView.loadGuestStats();
    await AdminView.loadAnalyticsUserList();
  }

  private static async loadGuestStats(): Promise<void> {
    const [statsRes, topGamesRes] = await Promise.all([
      ApiClient.getGuestStats(),
      ApiClient.getGuestTopGames(8),
    ]);

    const cardsEl = document.getElementById('guest-stats-cards');
    if (cardsEl) {
      if (statsRes.error || !statsRes.data) {
        cardsEl.innerHTML = `<div style="color:#ef4444;">${statsRes.error || 'Veri alınamadı'}</div>`;
      } else {
        const s = statsRes.data;
        const fmt = (ms: number) => ms > 3600000 ? `${(ms/3600000).toFixed(1)}s` : ms > 60000 ? `${(ms/60000).toFixed(0)}dk` : `${(ms/1000).toFixed(0)}sn`;
        const stats = [
          { icon: '👥', label: 'Tekil Ziyaret', val: s.unique_guests },
          { icon: '🎮', label: 'Toplam Oyun', val: s.total_plays },
          { icon: '⏱️', label: 'Toplam Süre', val: fmt(s.total_duration_ms || 0) },
          { icon: '📱', label: 'Mobil', val: s.mobile_count },
          { icon: '💻', label: 'Masaüstü', val: s.desktop_count },
          { icon: '📅', label: 'Son 7 Gün', val: s.plays_last_7_days },
        ];
        cardsEl.innerHTML = stats.map(st => `
          <div class="glass-panel" style="padding:16px; text-align:center;">
            <div style="font-size:1.8rem; margin-bottom:6px;">${st.icon}</div>
            <div style="font-size:1.4rem; font-weight:800; color:#f8fafc;">${st.val}</div>
            <div style="font-size:0.75rem; color:#64748b; margin-top:4px;">${st.label}</div>
          </div>
        `).join('');
      }
    }

    const topEl = document.getElementById('guest-top-games');
    if (topEl) {
      if (topGamesRes.error || !topGamesRes.data?.length) {
        topEl.innerHTML = `<div style="color:#64748b;">Henüz veri yok.</div>`;
      } else {
        const max = topGamesRes.data[0].play_count;
        topEl.innerHTML = topGamesRes.data.map(g => {
          const pct = Math.round((g.play_count / max) * 100);
          const mins = Math.round((g.total_duration_ms || 0) / 60000);
          return `
            <div style="display:flex; align-items:center; gap:12px;">
              <span style="width:140px; font-size:0.8rem; color:#cbd5e1; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">${g.game_id}</span>
              <div style="flex:1; background:#1e293b; border-radius:4px; overflow:hidden; height:20px;">
                <div style="width:${pct}%; background:linear-gradient(90deg,#6366f1,#a855f7); height:100%; transition:width 0.5s;"></div>
              </div>
              <span style="font-size:0.8rem; color:#94a3b8; min-width:80px; text-align:right;">${g.play_count} oyun · ${mins}dk</span>
            </div>
          `;
        }).join('');
      }
    }
  }

  private static async loadAnalyticsUserList(): Promise<void> {
    const res = await ApiClient.getUsers();
    const listEl = document.getElementById('analytics-user-list');
    if (!listEl) return;

    if (res.error || !res.data?.length) {
      listEl.innerHTML = `<div style="color:#64748b;">Kullanıcı bulunamadı.</div>`;
      return;
    }

    listEl.innerHTML = res.data.map(u => `
      <button
        class="analytics-user-btn"
        data-uid="${u.id}"
        style="width:100%; text-align:left; padding:10px 12px; border-radius:8px; border:1px solid #334155;
               background:transparent; color:#cbd5e1; cursor:pointer; transition:background 0.15s;
               display:flex; align-items:center; gap:10px; font-size:0.85rem;"
        onmouseover="this.style.background='#1e293b'" onmouseout="this.style.background='transparent'"
      >
        <span style="font-size:1.1rem;">👤</span>
        <div style="flex:1; min-width:0;">
          <div style="font-weight:700; color:#f8fafc; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">${u.username}</div>
          <div style="font-size:0.75rem; color:#64748b;">${u.role}</div>
        </div>
      </button>
    `).join('');

    listEl.querySelectorAll('.analytics-user-btn').forEach(btn => {
      btn.addEventListener('click', async () => {
        listEl.querySelectorAll('.analytics-user-btn').forEach(b => (b as HTMLElement).style.background = 'transparent');
        (btn as HTMLElement).style.background = '#334155';
        const uid = btn.getAttribute('data-uid')!;
        const user = res.data!.find(u => u.id === uid);
        if (user) await AdminView.loadUserDetail(uid, user.username);
      });
    });
  }

  private static async loadUserDetail(userId: string, username: string): Promise<void> {
    const detailEl = document.getElementById('analytics-user-detail');
    if (!detailEl) return;

    detailEl.innerHTML = `<div style="text-align:center; color:#64748b; padding:40px;">Yükleniyor...</div>`;

    const sessionsRes = await ApiClient.getUserSessions(userId);

    if (sessionsRes.error || !sessionsRes.data) {
      detailEl.innerHTML = `<div style="color:#ef4444; padding:20px;">${sessionsRes.error}</div>`;
      return;
    }

    const sessions = sessionsRes.data;
    const totalDuration = sessions.reduce((sum, s) => sum + (s.duration_ms || 0), 0);
    const uniqueGames = [...new Set(sessions.map(s => s.game_id))];
    const fmt = (ms: number) => ms > 3600000 ? `${(ms/3600000).toFixed(1)} saat` : ms > 60000 ? `${(ms/60000).toFixed(0)} dk` : `${(ms/1000).toFixed(0)} sn`;

    // Game counts
    const gameCounts: Record<string, number> = {};
    const gameDuration: Record<string, number> = {};
    sessions.forEach(s => {
      gameCounts[s.game_id] = (gameCounts[s.game_id] || 0) + 1;
      gameDuration[s.game_id] = (gameDuration[s.game_id] || 0) + (s.duration_ms || 0);
    });
    const topGames = Object.entries(gameCounts).sort((a, b) => b[1] - a[1]).slice(0, 8);
    const maxCount = topGames[0]?.[1] || 1;

    // Browser/Device/OS breakdown
    const browsers: Record<string, number> = {};
    const devices: Record<string, number> = {};
    const oses: Record<string, number> = {};
    sessions.forEach(s => {
      if (s.browser) browsers[s.browser] = (browsers[s.browser] || 0) + 1;
      if (s.device_type) devices[s.device_type] = (devices[s.device_type] || 0) + 1;
      if (s.os) oses[s.os] = (oses[s.os] || 0) + 1;
    });

    const deviceIcon = (d: string) => d === 'mobile' ? '📱' : d === 'tablet' ? '📲' : '💻';
    const osIcon = (o: string) => ({ Windows: '🪟', macOS: '🍎', iOS: '📱', Android: '🤖', Linux: '🐧' }[o] || '💻');

    // Last 7 days activity
    const now = Date.now();
    const activity: number[] = Array(7).fill(0);
    sessions.forEach(s => {
      const daysAgo = Math.floor((now - new Date(s.started_at || '').getTime()) / 86400000);
      if (daysAgo >= 0 && daysAgo < 7) activity[6 - daysAgo]++;
    });
    const maxActivity = Math.max(...activity, 1);
    const dayLabels = ['6g', '5g', '4g', '3g', '2g', 'Dün', 'Bug.'];

    const canvasId = `chart-${userId.replace(/-/g, '')}`;

    detailEl.innerHTML = `
      <div style="display:flex; flex-direction:column; gap:20px;">
        <!-- Header -->
        <div style="display:flex; align-items:center; gap:16px; flex-wrap:wrap;">
          <div style="width:48px; height:48px; border-radius:50%; background:linear-gradient(135deg,#6366f1,#a855f7); display:flex; align-items:center; justify-content:center; font-size:1.4rem;">👤</div>
          <div>
            <div style="font-size:1.3rem; font-weight:800; color:#f8fafc;">${username}</div>
            <div style="font-size:0.8rem; color:#64748b;">${sessions.length} oturum · ${uniqueGames.length} farklı oyun</div>
          </div>
          <div style="margin-left:auto; display:flex; gap:16px; flex-wrap:wrap;">
            <div style="text-align:center;">
              <div style="font-size:1.4rem; font-weight:800; color:#6366f1;">${sessions.length}</div>
              <div style="font-size:0.7rem; color:#64748b;">Toplam Oturum</div>
            </div>
            <div style="text-align:center;">
              <div style="font-size:1.4rem; font-weight:800; color:#a855f7;">${fmt(totalDuration)}</div>
              <div style="font-size:0.7rem; color:#64748b;">Toplam Süre</div>
            </div>
          </div>
        </div>

        <!-- 7-Day Activity -->
        <div>
          <div style="font-size:0.85rem; font-weight:700; color:#94a3b8; margin-bottom:10px;">Son 7 Gün Aktivitesi</div>
          <div style="display:flex; gap:6px; align-items:flex-end; height:60px;">
            ${activity.map((v, i) => `
              <div style="flex:1; display:flex; flex-direction:column; align-items:center; gap:4px;">
                <div style="width:100%; background:linear-gradient(0deg,#6366f1,#a855f7); border-radius:3px 3px 0 0;
                            height:${Math.round((v/maxActivity)*44)+2}px; transition:height 0.4s; min-height:2px;"
                     title="${v} oturum"></div>
                <div style="font-size:0.6rem; color:#64748b;">${dayLabels[i]}</div>
              </div>
            `).join('')}
          </div>
        </div>

        <!-- Top Games Bar Chart (Chart.js) -->
        ${topGames.length ? `
          <div>
            <div style="font-size:0.85rem; font-weight:700; color:#94a3b8; margin-bottom:10px;">En Çok Oynanan Oyunlar</div>
            <canvas id="${canvasId}" height="180"></canvas>
          </div>
        ` : ''}

        <!-- Device / Browser / OS -->
        <div style="display:grid; grid-template-columns:repeat(auto-fill,minmax(180px,1fr)); gap:12px;">
          <div class="glass-panel" style="padding:14px;">
            <div style="font-size:0.75rem; font-weight:700; color:#94a3b8; margin-bottom:8px; text-transform:uppercase;">Cihaz</div>
            ${Object.entries(devices).map(([d, n]) => `
              <div style="display:flex; justify-content:space-between; align-items:center; padding:4px 0; border-bottom:1px solid #1e293b;">
                <span style="color:#cbd5e1; font-size:0.85rem;">${deviceIcon(d)} ${d}</span>
                <span style="font-weight:700; color:#f8fafc;">${n}</span>
              </div>
            `).join('')}
          </div>
          <div class="glass-panel" style="padding:14px;">
            <div style="font-size:0.75rem; font-weight:700; color:#94a3b8; margin-bottom:8px; text-transform:uppercase;">Tarayıcı</div>
            ${Object.entries(browsers).map(([b, n]) => `
              <div style="display:flex; justify-content:space-between; align-items:center; padding:4px 0; border-bottom:1px solid #1e293b;">
                <span style="color:#cbd5e1; font-size:0.85rem;">🌐 ${b}</span>
                <span style="font-weight:700; color:#f8fafc;">${n}</span>
              </div>
            `).join('')}
          </div>
          <div class="glass-panel" style="padding:14px;">
            <div style="font-size:0.75rem; font-weight:700; color:#94a3b8; margin-bottom:8px; text-transform:uppercase;">İşletim Sistemi</div>
            ${Object.entries(oses).map(([o, n]) => `
              <div style="display:flex; justify-content:space-between; align-items:center; padding:4px 0; border-bottom:1px solid #1e293b;">
                <span style="color:#cbd5e1; font-size:0.85rem;">${osIcon(o)} ${o}</span>
                <span style="font-weight:700; color:#f8fafc;">${n}</span>
              </div>
            `).join('')}
          </div>
        </div>

        <!-- Recent Sessions Table -->
        <div>
          <div style="font-size:0.85rem; font-weight:700; color:#94a3b8; margin-bottom:10px;">Son Oturumlar</div>
          <div style="overflow-x:auto;">
            <table style="width:100%; border-collapse:collapse; font-size:0.8rem;">
              <thead>
                <tr style="border-bottom:1px solid #334155; color:#64748b;">
                  <th style="padding:8px; text-align:left;">Oyun</th>
                  <th style="padding:8px; text-align:left;">Süre</th>
                  <th style="padding:8px; text-align:left;">Cihaz</th>
                  <th style="padding:8px; text-align:left;">Tarayıcı</th>
                  <th style="padding:8px; text-align:left;">Tarih</th>
                </tr>
              </thead>
              <tbody>
                ${sessions.slice(0, 20).map(s => `
                  <tr style="border-bottom:1px solid #1e293b;">
                    <td style="padding:8px; color:#cbd5e1;">${s.game_id}</td>
                    <td style="padding:8px; color:#a5b4fc;">${fmt(s.duration_ms)}</td>
                    <td style="padding:8px; color:#94a3b8;">${deviceIcon(s.device_type || '')} ${s.device_type || '-'}</td>
                    <td style="padding:8px; color:#94a3b8;">${s.browser || '-'}</td>
                    <td style="padding:8px; color:#64748b;">${s.started_at ? new Date(s.started_at).toLocaleString('tr') : '-'}</td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    `;

    // Render Chart.js bar chart
    if (topGames.length) {
      const canvas = document.getElementById(canvasId) as HTMLCanvasElement;
      if (canvas) {
        const { Chart, BarController, BarElement, CategoryScale, LinearScale, Tooltip } = await import('chart.js');
        Chart.register(BarController, BarElement, CategoryScale, LinearScale, Tooltip);
        new Chart(canvas, {
          type: 'bar',
          data: {
            labels: topGames.map(([g]) => g),
            datasets: [{
              label: 'Oturum',
              data: topGames.map(([, c]) => c),
              backgroundColor: 'rgba(99,102,241,0.7)',
              borderColor: '#6366f1',
              borderWidth: 1,
              borderRadius: 4,
            }],
          },
          options: {
            responsive: true,
            plugins: { legend: { display: false }, tooltip: { mode: 'index' } },
            scales: {
              x: { ticks: { color: '#94a3b8', font: { size: 11 } }, grid: { color: '#1e293b' } },
              y: { ticks: { color: '#94a3b8', stepSize: 1 }, grid: { color: '#1e293b' }, beginAtZero: true },
            },
          },
        });
      }
    }
  }
}
